import React, { Component } from 'react';
import { Form, Input, Modal } from 'antd';

const FormItem = Form.Item;

class ModalAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    return (
      <Modal
        title="账户信息"
        visible
        onOk={this.submit}
        onCancel={() => this.props.onCancel(false)}
      >
        <Form>
          <FormItem label="客户名称" {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请输入客户名称' }],
              initialValue: data.customName,
            })(<Input />)}
          </FormItem>
          <FormItem label="客户联系人姓名" {...formItemLayout}>
            {getFieldDecorator('contactName', {
              initialValue: data.contactName,
            })(<Input />)}
          </FormItem>
          <FormItem label="客户联系方式" {...formItemLayout}>
            {getFieldDecorator('contactTel', {
              initialValue: data.contactTel,
            })(<Input />)}
          </FormItem>
          <FormItem label="法人姓名" {...formItemLayout}>
            {getFieldDecorator('legalName', {
              initialValue: data.legalName,
            })(<Input />)}
          </FormItem>
          <FormItem label="法人联系方式" {...formItemLayout}>
            {getFieldDecorator('legalTel', {
              initialValue: data.legalTel,
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/ModalBase.js